import styled from "styled-components";
import IconButton from '@mui/material/IconButton';

export const CourseCardsContainer = styled.div`
    display: flex;
    width: 100%;
    overflow: auto;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch; /* For iOS devices */
    /* Hide scrollbar for Chrome, Safari and Opera */
    ::-webkit-scrollbar {
        display: none;
    }
    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    padding: 20px;
    @media(min-width: 768px){
       padding: 35px;
    }
    @media(min-width: 1024px){
        padding: 50px;
    }
`;

export const CourseCategory = styled.div`
    
    background: rgba(0, 0, 0, 0.38);
    backdrop-filter: blur(14px);
    color: #FFFFFF;
    font-family: 'heroregular';
    font-style: normal;
    font-weight: 400;
    width: fit-content;
    cursor: default;

    padding: 2px;
    border-radius: 16px;
    font-size: 10px;
    line-height: 8px;

    @media(min-width: 768px){
        padding: 4px;
        border-radius: 21px;
        font-size: 12px;
        line-height: 12px;
    }
    @media(min-width: 1024px){
        padding: 7px;
        border-radius: 28px;
        font-size: 16px;
        line-height: 16px;
    }
`;

export const CourseTitle = styled.div`
    color: #FFFFFF;
    font-family: 'heroregular';
    font-style: normal;
    display: flex;
    justify-content: center;
    cursor: default;
    text-align: center;
    line-height: 1.1;

    width: 107px;
    font-weight: 600;
    font-size: 16px;
    @media(min-width: 768px){
        width: 187px;
        font-weight: 600;
        font-size: 21px;
    }
    @media(min-width: 1024px){
        width: 287px;
        font-weight: 600;
        font-size: 28px;
    }
`;

export const CourseCardBackground = styled.div`
    width: 100%;
    height: 100%;
    background-image: linear-gradient(180deg, rgba(43, 43, 43, 0) 36.99%, #2B2B2B 110.28%), url(${(props) => props.imgURL});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    transition: transform 0.5s ease-in-out;
`

export const CourseTitleAndPlay = styled.div`
    position: absolute;
    bottom: 0px;
    transform: translateY(15px);
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: transform 0.5s ease-in-out;
    @media (min-width: 768px) {
        transform: translateY(30px);
    }
    @media(min-width: 1024px){
        transform: translateY(45px);
    }
`

export const CourseInfoSeparator = styled.div`
    background: #FFFFFF;
    height: 4px;
    width: 20px;
    margin: 5px 0px;
`;

export const CoursePlayButton = styled.div`
    opacity: 0;
    transition: opacity .5s ease-out;
    display: flex;
    background: #FFFFFF;
    border-radius: 6px;
    justify-content: center;
    align-items: center;
    font-family: 'heroregular';
    font-style: normal;
    font-weight: 600;
    color: #000000;
    cursor: pointer;

    font-size: 8px;
    width: 75px;
    height: 20px;
    margin-top: 6px;

    @media(min-width: 768px){
        font-size: 12px;
        width: 100px;
        height: 25px;
        margin-top: 9px;
    }
    @media(min-width: 1024px){
        font-size: 16px;
        width: 150px;
        height: 40px;
        margin-top: 12px;
    }
`;

export const CourseCard = styled.div`
    flex: 0 0 129px;
    height: 138px;
    margin-right: 30px;
    border-radius: 5px;
    position: relative;
    overflow: hidden;
    &:hover {
        ${CourseCardBackground} {
            transform: scale(1.05);
        }
        ${CourseTitleAndPlay}{
            transform: translateY(-15px);
        }
        ${CoursePlayButton}{
            opacity: 1;
        }
    }
    
    @media(min-width: 768px){
        flex: 0 0 229px;
        height: 238px;
        margin-right: 60px;
        border-radius: 8px;
    }
    @media(min-width: 1024px){
        flex: 0 0 329px;
        height: 338px;
        margin-right: 90px;
        border-radius: 10px;
    }
`;